import React from 'react';
import './Health.css';
import img9 from '../Assets/healthImg1.jpg'
import img10 from '../Assets/healthImg2.jpg'
import img11 from '../Assets/healthImg3.png'
import img12 from '../Assets/healthImg4.jpeg'

function Health() {
  return (
    <div className="health-container">
      <div className="health-hero">
        <h1>Healthcare Initiatives</h1>
        <p>Improving Community Health and Wellbeing in Underserved Areas</p>
      </div>
      
      <div className="health-content">
        <div className="health-section">
          <div className='healthflexbox'>
            <div className='healthTextbox'>
              <h2>Healthcare & Medical Support</h2>
              <p>Volunteer Impact Initiative undertakes projects which focuses on providing essential health services and support to underserved communities in Ghana, particularly in rural and remote areas where access to healthcare is limited.</p>
              <p>Volunteers will collaborate with local health professionals at clinics, hospitals, and community health centers, contributing to a wide range of activities such as health education, basic medical care, and patient support.</p>
              <p>The initiative aims to improve overall community health through preventive care, health screenings, and education on hygiene and disease prevention. Volunteers with skills in nursing, medicine, public health, or even a passion for helping others are encouraged to participate.</p>
              <p>Compassion, adaptability, and a willingness to learn are key, as volunteers will be working in diverse and often challenging environments. Your involvement will not only provide crucial healthcare support but also help to build healthier and more resilient communities.</p>
              
              

            </div>
            
          </div>
        </div>
            <div className='healthImgGrid'>
              <img src={img9} alt='Medical volunteer conducting health screening' className='healthImg'/>
              <img src={img10} alt='Community health education session' className='healthImg'/>
              <img src={img11} alt='Vaccination program in rural area' className='healthImg'/>
              <img src={img12} alt='Volunteer assisting elderly patient' className='healthImg'/>
            </div>
        
        

        
      </div>
        <div className="call-to-action">
          <h2>Join Our Healthcare Mission</h2>
          <p>Your medical skills and compassion can save lives and build healthier communities</p>
          <a href='/VolunteerNow'><button className="cta-button">Volunteer in Health</button></a>
        </div>
    </div>
  );
}

export default Health;